import {
  type GetInterviewsResponse,
  InterviewStatus,
  useFetchPaginatedInterviews,
} from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";
import { type UseInfiniteQueryOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { subMonths } from "date-fns";

import { PlacementApplicationStatus } from "../types/fetchPlacements.schema";

export function useInterviewAttendanceOutcome(
  {
    workerId,
    withDismissed,
  }: {
    workerId: string;
    withDismissed: boolean;
  },
  options: UseInfiniteQueryOptions<GetInterviewsResponse, AxiosError> = {}
) {
  const today = new Date();
  return useFetchPaginatedInterviews(
    {
      sort: "-start",
      filter: {
        workerId,
        status: InterviewStatus.ATTENDANCE_CONFIRMED,
        start: {
          gt: subMonths(
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            2
          ).toISOString(),
        },
        ...(withDismissed ? { "workerOutcome.dismissedAt": { isNull: true } } : undefined),
        "workerOutcome.result": { isNull: true },
        "placementApplication.status": [
          PlacementApplicationStatus.ACCEPTED,
          PlacementApplicationStatus.APPLIED,
          PlacementApplicationStatus.INTERVIEW,
          PlacementApplicationStatus.INTERVIEW_CONFIRMED,
          PlacementApplicationStatus.INTERVIEW_CANCELLED,
          PlacementApplicationStatus.INTERVIEW_HELD,
          PlacementApplicationStatus.INTERVIEW_NOT_CONFIRMED,
          PlacementApplicationStatus.INTERVIEW_NOT_SHOWED,
          PlacementApplicationStatus.INTERVIEW_TURNED_AWAY,
        ].join(","),
      },
    },
    options
  );
}
